import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Unstable_Alert2 as Alert,
  AlertTitle,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import { useEnableFido } from '@/components/biz/fido/use-fido';
import { MySvgIcon } from '@/components/ui/svg-icon';
import { Flow } from '@/constants/flow';
import { useBizState } from '@/hooks/use-biz-state';
import { useFidoSkip } from '@/hooks/use-fido-skip';
import { useFlow } from '@/hooks/use-flow';
import { StepBox } from '../../layout/step-box';

interface StepEnablePasskeyProps {
  title: string;
}

export const StepEnablePasskey: React.FC<StepEnablePasskeyProps> = ({ title }) => {
  const { callBack } = useBizState();
  const { setFlow } = useFlow();
  const { t } = useTranslation();
  const [skipEnableFido, setSkipEnableFido] = useState<boolean>(false);
  const { setFidoSkip } = useFidoSkip();
  const { run, loading, error } = useEnableFido();

  const handleTellMe = () => {
    setSkipEnableFido(!skipEnableFido);
  };

  const skip = () => {
    setFidoSkip(skipEnableFido);

    if (callBack) {
      window.location.href = callBack;
      return;
    }
    setFlow(Flow.EXCEPTION_SOMETHING_WENT_WRONG);
  };

  return (
    <StepBox title={title}>
      <Stack
        direction={{
          xs: 'column-reverse',
          sm: 'row',
        }}
        spacing={3}
        alignItems={{
          xs: 'center',
          sm: 'start',
        }}
        justifyContent="space-between"
      >
        <Stack>
          <Typography variant="subtitle1" gutterBottom>
            {t('passkey_skip_description')}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {t('passkey_feature_description')}
          </Typography>
        </Stack>
        <MySvgIcon name="fido" aria-hidden="true" width="116" height="87" />
      </Stack>

      {error && (
        <Alert severity="error">
          {error.title && <AlertTitle>{t(error.title)}</AlertTitle>}
          {t(error.message)}
        </Alert>
      )}

      <Stack spacing={2} mt={2}>
        <Button variant="contained" loading={loading} onClick={run}>
          {t('enable_passkey')}
        </Button>
        <Button variant="contained" disabled={loading} color="secondary" onClick={skip}>
          {t('skip')}
        </Button>
        <FormControlLabel
          control={<Checkbox name="tell" />}
          label={t('dont_remind_again_checkbox')}
          onChange={handleTellMe}
        />
      </Stack>
    </StepBox>
  );
};
